export function getBackgroundImage(event, defaultScoreboardImages) {
    const images = defaultScoreboardImages[event.sportId] || defaultScoreboardImages["0"];
    if (!images) {
        return "";
    }
    return event.isLive ? images.liveImage : images.preLiveImage;
}
//# sourceMappingURL=getBackgroundImage.js.map